import React, { useEffect, useState } from "react";
import SideBar from "../../Components/Navbar/Sidebar";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-modal";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getVendorData, insertSiteData } from "../../Components/Apis/apis";
import instance from "../../Components/Apis/axios";
import Loader from "../../Components/loader";
import { useLocation} from "react-router-dom";
const Sities = () => {
  function imageFormatter(cell) {
    return <img src={cell} style={{ width: "100px", height: "100px" }} />;
  }
  const columns = [
    { dataField: "thumb", formatter: imageFormatter, text: "Image" },
    { dataField: "location", text: "location", sort: true },
    { dataField: "city_name", text: "City", sort: true },
    { dataField: "category_name", text: "Category", sort: true },
    { dataField: "subcategory", text: "Subcategory", sort: true },
    { dataField: "illumination", text: "Illumination", sort: true },
  ];
  
  let locations = useLocation();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [state, setState] = useState([]);
  const [open, setopen] = useState(false);
  const [vendorName, setVendorName] = useState([]);
  const [posts, setPosts] = useState();
  const [site, setSite] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [showSite, setShowSite] = useState(false[0]);
  const [code,setCode]=useState();
  const [noStateData, setStateData] = useState(false);
  const path = locations.pathname;
  const getData = async () => {
    const data = await getVendorData();
    setState(data);
  };

  const headers = [
    { key: "Vendors", label: "Vendors" },
    { key: "campaign Name", label: "Campaign Name" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone Number" },
    { key: "added_site", label: "All Sites" },
    { key: "Add Sites", label: "Add Sites" },
  ];
  useEffect(() => {
    getData();
  }, []);

  const ShowDetails = async (e) => {
    e.preventDefault();
    setLoading2(true);
    const detail={
      code:code
    }
    //Main Api to get Data
    const { data } = await instance.post(
      `media/inventory?path=${path}`,
      detail
    );
    if (data.res.length == 0) {
      setLoading2(false);
      setStateData(true);
      const updatedPosts = {
        category_name:  "",
        subcategory:  "",
        location:  "",
        illumination:  "",
        city: "",
        size:""
      };
      setPosts(updatedPosts);
      setMainData([]);
    } else {
      setMainData(data.res);
      const firstItem = data.res[0];
      const updatedPosts = {
        category_name: firstItem.category_name || "",
        subcategory: firstItem.subcategory || "",
        location: firstItem.location || "",
        illumination: firstItem.illumination || "",
        city: firstItem.city_name || "",
        size:  "not"
      };
      setPosts(updatedPosts);
      setLoading2(false);
      setStateData(false);
    }
  };

  const addSite = async (e) => {
    e.preventDefault();
    setLoading3(true);
    if (
      posts.category_name !== "" &&
      posts.subcategory !== "" &&
      posts.location !== "" &&
      posts.illumination !== "" &&
      posts.city !== "" &&
      posts.size !== ""
    ) {
      const vendorname = vendorName.vendors;
      const campaign_Id = vendorName.campaign_id;

      const data = await insertSiteData(posts, vendorname, campaign_Id);

      if (data.message === "Success") {
        toast("Site added Successfully");
        setLoading3(false);
        setopen(!open);
        setPosts();
        setCode();
        setMainData([]);
        setStateData(false);
      }
    } else {
      alert("Somthing went wrong!");
    }
  };

  const toggle = (index) => {
    if (showSite === index) {
      return setShowSite(null);
    }
    setShowSite(index);
  };

  const getDataSite = async (datas) => {
    const campaign_Id = datas.campaign_id;
    const vendorname = datas.vendors;
    const { data } = await instance.get(
      `vendorData/campaignvendorsite/${campaign_Id}/${vendorname}`
    );
    setSite(data);
  };

  const closeModal=()=>{
    setopen(!open) 
    setMainData([])
    setCode()
    setStateData(false)
  }
  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        {loading ? (
          <Loader />
        ) : (
          <>
            {state.length == 0 ? (
              <h2 className="text-secondary">No Campaign found for add sites</h2>
            ) : (
              <>
                <table className="table table-boarder table-hover table-striped  table-sm">
                  <thead className="thead-dark">
                    <tr>
                      {headers.map((row) => {
                        return (
                          <td key={row.key} className="fw-bold">
                            {row.label}
                          </td>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {state &&
                      state.map((el, index) => (
                        <>
                          <tr key={index}>
                            <td>{el.vendors}</td>
                            <td>{el.campaign_name}</td>
                            <td>{el.email}</td>
                            <td>{el.phone}</td>
                            <td>
                              <button
                                className="button is-small is-info show-btn border-0"
                                onClick={() => {
                                  getDataSite(el);
                                  toggle(index);
                                }}
                              >
                                Show
                              </button>
                            </td>
                            <td>
                              <button
                                className="button is-small is-info show-btn border-0"
                                onClick={() => {
                                  setopen(!open);
                                  setVendorName(el);
                                }}
                              >
                                Add Site
                              </button>
                            </td>
                          </tr>
                          <tr className="modalView">
                            {showSite === index ? (
                              <td colSpan={7}>
                                {site.length > 0 ? (
                                  <>
                                    <div>
                                      <div className="dataModal">
                                        <table className="table table-boarder table-hover table-striped  table-sm">
                                          <thead>
                                            <tr>
                                              <th scope="col ">SL.</th>
                                              <th scope="col">Category</th>
                                              <th scope="col">Sub-category</th>
                                              <th scope="col">Location</th>
                                              <th scope="col">City</th>
                                              <th scope="col">illumination</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {site &&
                                              site.map((e, i) => (
                                                <tr key={i}>
                                                  <td>{i+1}</td>
                                                  <td>{e.category_name}</td>
                                                  <td>{e.subcategory}</td>
                                                  <td>{e.location}</td>
                                                  <td>{e.city}</td>
                                                  <td>{e.illumination}</td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="noDataModal">
                                      <span>
                                        <i class="fa-solid fa-triangle-exclamation"></i>
                                        NoData
                                      </span>
                                    </div>
                                  </>
                                )}
                              </td>
                            ) : null}
                          </tr>
                        </>
                      ))}
                  </tbody>
                </table>
              </>
            )}
          </>
        )}
      </div>
        <Modal isOpen={open} className="mt-5  w-75">
        <button
    className="border-0 bg-info float-right"
    onClick={() =>closeModal()}
>
    X
</button>


        <div>
        <form className="form" onSubmit={ShowDetails}>
                <div>
                  <label for="search">Media Code :</label>
                  <input
                    type="text"
                    id="search"
                    name="code"
                    value={code}
                    placeholder="Media code .."
                    onChange={(e)=>setCode(e.target.value)}
                    autoFocus
                  
                    required
                  />
                </div>
                <input type="submit" value={loading2 ? "Searching..." : "Search"} />

        </form>
     {noStateData && <p className="text-danger">No sites found</p>}  


                   <ToolkitProvider
                      keyField="code"
                      data={mainData}
                      columns={columns}
                    
                    >
                      {(props) => (
                        <BootstrapTable
                        {...props.baseProps}
                      
                        noDataIndication="Table is Empty"
                      />
                      )}
                    </ToolkitProvider>

                    <br />
          <button
            className="border-0 text-light bg-info  w-25 float-right"
            onClick={addSite}
          >
        {loading3?"Site adding...":"Add this Site" }    
          </button>
        </div>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default Sities;
